












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class InstitutionTop10GrowthChart extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  keyValue: number;

  @Prop()
  growth: boolean;

  chartData: any[] = [];
  chartOptions: any = {};

  mounted() {
    this.load();
    this.buildChartOptions();
  }

  buildChartOptions() {
    if (!this.kpis) {
      return;
    }
    let kpisUse = this.kpis;
    let paddingHeight = 10;
    let rowHeight = kpisUse.length * 50;
    let chartHeight = rowHeight + paddingHeight;

    if (chartHeight < 100) {
      chartHeight = 100;
    }

    this.chartOptions = {
      tooltip: {
        isHtml: true
      },
      height: chartHeight,
      backgroundColor: 'transparent',
      chartArea: { left: '100', top: '0', right: '80', bottom: '50', height: rowHeight },
      legend: { position: 'bottom' },
      isStacked: false,
      fontSize: 12,
      colors: ['#1F4E79', this.growth ? '#2E8B57' : '#D64541']
    };
  }

  load() {
    if (!this.kpis) {
      return;
    }
    this.chartData = [];
    let kpisUse = this.kpis;

    this.chartData.push([
      'Instituição',
      kpisUse[0] ? kpisUse[0].mesAnterior : 0,
      { type: 'string', role: 'tooltip', p: { html: true } },
      kpisUse[0] ? kpisUse[0].mesAtual : 0,
      { type: 'string', role: 'tooltip', p: { html: true } },
      { role: 'annotation' }
    ]);
    kpisUse.forEach((i) => {
      this.chartData.push([
        `${i.nomeInstituicao.substring(0, i.nomeInstituicao.indexOf('-')).trim()}`,
        i.qtdeMesAnterior,
        this.getTooltip(i.nomeInstituicao, i.mesAnterior, i.qtdeMesAnterior),
        i.qtdeMesAtual,
        this.getTooltip(i.nomeInstituicao, i.mesAtual, i.qtdeMesAtual),
        this.getAnnotation(i)
      ]);
    });
  }

  getAnnotation(i) {
    let an = `${this.growth ? '▲' : '▼'}${Math.abs(i.crescimentoAbs)}`;
    if (Math.abs(i.crescimentoPerc) != 0) {
      an += ` (${this.growth ? '+' : ''}${
        Math.abs(i.crescimentoPerc) != 0 ? this.decimalFormatHelper(i.crescimentoPerc, 0) + '%' : ''
      })`;
    }
    return an;
  }

  getTooltip(nome, tipo, qtde) {
    return `<div style="padding:8px; white-space:nowrap"><b>${nome}</b><br>${tipo}: <b>${qtde} prescrições</b></div>`;
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.buildChartOptions();
    this.load();
  }
}
